import { type RecentPlanChange, STATUS_COLOR_MAP } from '@/types/billing';
import { CUT_FEE_MAP } from '@consts/company';
import { Box, Chip, Paper, Typography } from '@mui/material';
import dayjs from 'dayjs';
import utc from 'dayjs/plugin/utc';
import { useState } from 'react';

dayjs.extend(utc);

export const RecentActivityCard = ({ change }: { change: RecentPlanChange }) => {
    return (
        <Paper
            key={`${change.StationID}-${change.LastStatusUpdate}`}
            sx={{
                p: 2,
                mb: 2,
                border: '1px solid #e0e0e0',
                borderRadius: '4px',
                // Ensure sufficient width on desktop carousel so right-aligned timestamp has space.
                minWidth: { sm: 320 },
                flex: { sm: '0 0 auto' },
            }}
            elevation={0}>
            <Box display='flex' justifyContent='space-between' alignItems='center' pb={1}>
                <Box display='flex' alignItems='center' gap={1}>
                    <Typography variant='subtitle1' fontWeight={600}>
                        {change.SerialNumber ? `Serial # ${change.SerialNumber}` : `Station #${change.StationID}`}
                    </Typography>
                    <Chip
                        label={
                            change.Status === 'Executed'
                                ? `${CUT_FEE_MAP[change.TargetPlanID]}`
                                : `${CUT_FEE_MAP[change.CurrentPlanID]} → ${CUT_FEE_MAP[change.TargetPlanID]}`
                        }
                        size='medium'
                        sx={{
                            backgroundColor: 'rgba(229, 57, 53, 0.2)',
                            color: 'rgba(229, 57, 53, 1)',
                            fontSize: '12px',
                            fontWeight: 600,
                            height: 22,
                        }}
                    />
                    <Chip
                        label={change.Status}
                        color={STATUS_COLOR_MAP[change.Status as keyof typeof STATUS_COLOR_MAP]}
                        size='small'
                        sx={{ height: 22, fontWeight: 600 }}
                    />
                </Box>
                <Typography variant='caption' color='text.secondary' sx={{ ml: 2 }}>
                    {dayjs.utc(change.LastStatusUpdate).fromNow()}
                </Typography>
            </Box>

            <Typography variant='body2' color='text.primary'>
                Company: {`${change.CompanyName}`}
            </Typography>
            <Typography variant='body2' color='text.primary' sx={{ mt: 0.5 }}>
                Location: {`${change.LocationName}`}
            </Typography>
            <Typography variant='body2' color='text.primary' sx={{ mt: 0.5 }}>
                {`Effective: ${dayjs.utc(change.EffectiveDate).format('MMM DD, YYYY')}`}
            </Typography>
            {change.Justification && (
                <Typography variant='body2' color='text.primary' sx={{ mt: 0.5 }}>
                    {`Justification: ${change.Justification}`}
                </Typography>
            )}
        </Paper>
    );
};
